var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"composer",staticClass:"composer embed",attrs:{"id":"vendasta-composer","data-test":"composer","src":_vm.composerUrl,"title":"Composer"},on:{"load":_vm.handleVendastaLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }